import { cn } from '@shared/utils';
import type { GetLettersResponse } from '@shared/api';

interface TabProps {
  tab: GetLettersResponse;
  idx: number;
  className?: string;
  onOpenTab: (id: string, e: React.MouseEvent<HTMLDivElement>, tab: GetLettersResponse, key: number) => void;
  onDeleteTab: (idx: number) => void;
}

export const Tab = (props: TabProps) => {
  const handleDeleteClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    props.onDeleteTab(props.idx);
  };

  return (
    <div
      className={cn(
        'mt-px flex h-[42px] w-[263px] cursor-pointer justify-end rounded-t-xl bg-[#272727] pr-6 pl-10',
        'max-md:flex max-md:h-auto max-md:w-full max-md:items-center max-md:justify-between max-md:gap-4 max-md:px-4 max-md:py-2',
        props.className,
      )}
      onClick={(e) => props.onOpenTab(props.tab?.id, e, props.tab, props.idx)}
    >
      <div className='flex items-center overflow-hidden font-[ProximaNova-Medium] text-lg font-medium text-[#e5c496]'>
        <span className='block max-w-full overflow-hidden text-ellipsis whitespace-nowrap'>{props.tab?.subject || 'new message'}</span>
      </div>
      <div className='ml-auto flex items-center font-medium text-[#e5c496]'>
        <div
          className='mr-5 cursor-pointer text-3xl font-medium text-[#e5c496] max-md:m-0 max-md:flex max-md:h-[40px] max-md:w-[40px] max-md:items-center max-md:justify-center'
          onClick={(e) => props.onOpenTab(props.tab?.id, e, props.tab, props.idx)}
        >
          +
        </div>
        <span className='cursor-pointer text-[#e5c496] max-md:m-0 max-md:flex max-md:h-[40px] max-md:w-[40px] max-md:items-center max-md:justify-center'>
          <div
            className='mb-1 rotate-45 cursor-pointer text-3xl font-normal text-[#e5c496] max-md:m-0 max-md:flex max-md:h-[40px] max-md:w-[40px] max-md:items-center max-md:justify-center'
            onClick={handleDeleteClick}
          >
            +
          </div>
        </span>
      </div>
    </div>
  );
};
